import styled from '@emotion/styled';
import { borderRadii } from 'app/spacing';
import KizenTypography from 'app/kizentypo';

export default styled(({ children, ...props }) => {
  if (typeof children === 'string') {
    return (
      <KizenTypography as="div" {...props}>
        {children}
      </KizenTypography>
    );
  }
  return <div {...props}>{children}</div>;
})`
  padding: 10px;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'var(--color-feedback-info-bg)'};
  border-radius: ${borderRadii.small};
`;
